import { useUserStore } from "@/stores/UserStore";
import { useMetaAudienceStore } from "@/stores/MetaAudienceStore";

export const getUserHaloAudiences = (user) => {
  if (user?.meta_audiences != null) {
    return user.meta_audiences.filter(
      (aud) =>
        (aud.audience_type?.name === "Freemium" ||
          aud.audience_type?.name === "Premium") &&
        aud.audience_category?.name === "Halo",
    );
  }
  return user?.premium_audiences ?? [];
};

export const usersAllowedHaloAudiences = () => {
  const userStore = useUserStore();
  const metaAudienceStore = useMetaAudienceStore();
  const userHaloAudiences = getUserHaloAudiences(userStore.currentUser);
  const userPremiumAudienceIds = userHaloAudiences.map((aud) => aud.id);

  return metaAudienceStore.haloPremiumAudiences
    .filter((halo) => {
      return userPremiumAudienceIds?.includes(halo.id);
    })
    .map((halo) => halo.id);
};
